(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/components/email-footer.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/components/email-footer.js');
'use strict';

const {
  ReactInfoButtonText
} = svs.tb_ui;
const {
  showEmailUseInformation
} = svs.myProfile.react.pages.myInformation.myInformation.emailDialogs;
const handleShowEmailUseInfo = e => {
  e.preventDefault();
  showEmailUseInformation();
};

const EmailFooter = () => React.createElement(React.Fragment, null, React.createElement(ReactInfoButtonText, {
  onClick: handleShowEmailUseInfo,
  text: "Hur anv\xE4nder vi din e-post?"
}), React.createElement("p", {
  className: "margin-top-1"
}, React.createElement("a", {
  className: "u-text-decoration-underline",
  href: svs.core.urlMapping.get('termsIntegrityPersonData')
}, "L\xE4s mer"), ' ', "om hur AB Svenska Spel hanterar dina personuppgifter."));
svs.myProfile.react.pages.myInformation.myInformation.email.EmailFooter = EmailFooter;

 })(window);